<script>
    import { token } from "../store/token.js";
    import { user } from "../store/user.js";
    import { section } from "../store/section.js";

    let email;
    let password;
    let error_message;

    const url_search_params = new URLSearchParams(window.location.search);
    const url_params = Object.fromEntries(url_search_params.entries());

    const handle_token_exchange = async () => {
        const login_response = await fetch(
            `${process.env.API_ROOT}/token/exchange/jwt`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ access_token: url_params.access_token }),
            }
        );

        const response = await login_response.json();

        console.log(response);

        if (response.code) {
            error_message = response.message;
            return;
        }

        token.set(response.token);

        console.log(response.user);
        user.set(response.user);

        return;
    };

    setTimeout(() => {
        handle_token_exchange();
    }, 1000);
</script>

<div class="modal-bg large">
    <div class="modal-window">
        <div class="modal-header">
            <div class="f4">Control by Vollume</div>
            <div class="modal-close">
                <div class="icon-modal-close w-embed" />
            </div>
        </div>
        <div class="modal-body">Logging you in</div>
    </div>
</div>
